module.exports = __webpack_public_path__ + "static/serverRepair-5b7616e10f6f81b04b3a83f19b08591e.jpg";